import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ExamplePanel from '../Helpers/ExamplePanel';
import Footer from '../Helpers/Footer';
import PageTitle from '../Helpers/PageTitle';
import Sidebar from '../Helpers/Sidebar';
import Toolbar from '../Helpers/Toolbar';
import { Alert } from 'reactstrap';
import { checkDepartmentLicense } from '../../api/department';
import { store } from '../../utils/store';
import { actionConstants } from '../../actions/actionConstants';
import { useTranslation, withTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { getCurrentProfile } from '../../actions/general.action';

function Backend({ t, ...props }) {
  const removeBodyClass = () => {
    document.body.classList.remove('content-side-open');
  };
  const dispatch = useDispatch();
  const { department } = store.getState();
  async function checkLicense() {
    if (!department.checkDepartmentLicenseOnce) {
      await checkDepartmentLicense()
        .then((resp) => {
          store.dispatch({
            type: actionConstants.CHECK_DEPARTMENT_LICENSE_ONCE,
            data: true,
          });
          if (resp) {
            store.dispatch({
              type: actionConstants.SET_LICENSE_EXPIRATION,
              data: resp,
            });
            if (resp.expiredDays <= 30) {
              store.dispatch({
                type: actionConstants.SHOW_LICENSE_EXPIRATION_NOTIFICATION,
                data: true,
              });
            }
          }
        })
        .catch((err) => console.log(err));
    }
  }
  const { general } = store.getState();
  async function checkProfile() {
    if (!Object.keys(general.currentProfile).length) {
      dispatch(getCurrentProfile());
    }
  }
  React.useEffect(() => {
    checkLicense();
    checkProfile();
  }, []);

  return (
    <div className="page-inner">
      {props.noNavigation ? null : (
        <>
          <Toolbar />
          <Sidebar />
        </>
      )}

      <div className="main">
        {department.showLicenseExpirationNotification ? (
          <Alert
            color="warning"
            className="mb-0"
            toggle={() =>
              store.dispatch({
                type: actionConstants.SHOW_LICENSE_EXPIRATION_NOTIFICATION,
                data: false,
              })
            }
          >
            {t('Your license will expire in')}{' '}
            {department.licenseExpiration &&
              department.licenseExpiration.expiredDays}{' '}
            {t('days. Please contact your system administrator for renewal.')}
          </Alert>
        ) : null}

        <PageTitle title={props.title} />
        <div className="content">{props.children}</div>
        <Footer />
      </div>

      <div className="content-side-wrapper">
        <div className="content-side-overlay" onClick={removeBodyClass} />

        <div className="content-side">
          <ExamplePanel />
        </div>
      </div>
    </div>
  );
}

Backend.propTypes = {
  children: PropTypes.node.isRequired,
};

function mapStateToProps(state) {
  return {
    general: state.general,
  };
}

// function mapDispatchToProps(dispatch) {
//   return {
//     configureActions: bindActionCreators(
//       Object.assign({}, configureActions),
//       dispatch,
//     ),
//     generalActions: bindActionCreators(
//       Object.assign({}, generalActions),
//       dispatch,
//     ),
//   };
// }

// export default connect(mapStateToProps, mapDispatchToProps)(Backend);
export default withTranslation('app')(Backend);
